<div class="datepicker">
  <input
    matInput
    [min]="minDate"
    [max]="maxDate"
    [matDatepicker]="picker"
    [formControl]="form"
    [placeholder]="placeholder"
    (click)="picker.open()"
    (dateChange)="onChange()"
    [class.disabled]="disabled"
    [disabled]="form.disabled"
    [style]="inputStyle"
  />
  <ng-container *ngIf="!disabled">
    <mat-datepicker-toggle matSuffix [for]="picker">
      <mat-icon svgIcon="calendar" matDatepickerToggleIcon></mat-icon>
    </mat-datepicker-toggle>
  </ng-container>

  <mat-datepicker
    [dateClass]="dateService.dateClass"
    touchUi
    kidspicker
    #picker
  ></mat-datepicker>
</div>
<ng-container *ngIf="form.invalid && (form.dirty || form.touched)">
  <mat-error *ngIf="!hasRangeError()">日付を入力して下さい</mat-error>
  <mat-error *ngIf="hasRangeError()"
    >前後3ヶ月以内の日付を入力して下さい</mat-error
  >
</ng-container>
